import classnames from '@/utilities/classnames';
import React from 'react';

export interface StickyBoxProps {
  offsetTop?: number;
  shouldUpdate?: (cb: () => void) => void;
  children?: React.ReactNode;
}

interface StickyBoxState {
  sticky: boolean;
}

class StickyBox extends React.Component<StickyBoxProps, StickyBoxState> {
  static defaultProps: Partial<StickyBoxProps> = { offsetTop: 30 };
  private static EVENTS_NAMES = ['scroll', 'resize'];

  elementRef: HTMLDivElement | null;
  rect: ClientRect | DOMRect;
  mountedTop: number = 0;

  constructor(props: StickyBoxProps) {
    super(props);
    this.state = {
      sticky: false,
    };
  }

  handleDocumentScroll: () => void = () => {
    this.setState(() => ({
      sticky: this.top > (this.rect.top > 0 ? this.rect.top : this.mountedTop),
    }));
  };

  get top(): number {
    return (
      (document.documentElement.scrollTop || document.body.scrollTop) +
      this.props.offsetTop!
    );
  }

  componentDidMount() {
    const rect = this.elementRef && this.elementRef.getBoundingClientRect();
    const top = this.top;

    if (rect) {
      this.rect = rect;
      this.mountedTop =
        top > rect.top ? top + rect.top - this.props.offsetTop! : rect.top;
    }

    if (this.props.shouldUpdate) {
      this.props.shouldUpdate(this.handleDocumentScroll);
    }

    StickyBox.EVENTS_NAMES.forEach((eventName) =>
      window.addEventListener(eventName, this.handleDocumentScroll, {
        passive: true,
      })
    );
  }

  componentWillUnmount() {
    StickyBox.EVENTS_NAMES.forEach((eventName) =>
      window.removeEventListener(eventName, this.handleDocumentScroll)
    );
  }

  render() {
    const { children, offsetTop } = this.props;
    const classNames = classnames('StickyBox', {
      'StickyBox--sticky': this.state.sticky,
    });

    const style = {
      paddingBottom:
        (this.state.sticky && this.rect && this.rect.height + offsetTop!) || 0,
      width: (this.state.sticky && this.rect && this.rect.width) || 'auto',
      top: this.state.sticky ? offsetTop : 0,
    };

    return (
      <div
        className={classNames}
        ref={(r) => (this.elementRef = r)}
        style={style}
      >
        <div className="StickyBox__wrap">{children}</div>
      </div>
    );
  }
}

export default StickyBox;
